import { approvalStateApi, ekycApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async initPrescreeningDashboard({ commit, dispatch }, params) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchApprovalStates'),
      dispatch('fetchSummaries'),
      dispatch('fetchItems', params),
    ];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchApprovalStates({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await approvalStateApi.requestAll(token);
      commit('setApprovalStates', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchSummaries({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await ekycApi.requestKycKybSummary(token);
      commit('setSummaries', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async incrementItems({ commit, dispatch }, params) {
    commit('setAdding', true);
    await dispatch('fetchItems', params);
    commit('setAdding', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async refreshItems({ commit, dispatch }, params) {
    commit('setRefreshing', true);
    commit('setItems', []);
    await dispatch('fetchItems', params);
    commit('setRefreshing', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {Object} params
   */
  async fetchItems({ commit, rootGetters }, params) {
    const token = rootGetters['auth/token'];
    try {
      const response = await ekycApi.requestList(token, params);
      if (response.data.result && response.data.result.length > 0) {
        commit('addItems', response.data.result);
      }
      commit('setPaging', response.data.paging);
    }
    catch (error) {
      commit('setError', error);
    }
  },
};
